import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';
import CustomSelect from '../../../components/widgets/CustomSelect';

/**
 * ScrollToTop 버튼 유형 제어 컴포넌트
 */
const ScrollToTopButtonControl = () => {
  const { themeConfig, set } = useTheme();
  const currentThemeConfig = themeConfig || {};
  const buttonType = currentThemeConfig.scrollToTopButtonType || 'default';

  return (
    <div style={{ marginBottom: '15px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1 }}>
          <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>
            ⬆️ Top 버튼 유형:
          </label>
        </div>
      </div>

      <div style={{ marginBottom: '12px' }}>
        <CustomSelect
          value={buttonType}
          onChange={(v) => set('scrollToTopButtonType', v)}
          isSearchable={false}
          isClearable={false}
          options={[
            { value: 'default', label: '기본 (화살표만)' },
            { value: 'with-text', label: '화살표 + TOP 텍스트' },
          ]}
          styles={{
            control: (base, state) => ({
              ...base,
              width: '100%',
              minHeight: 34,
              fontSize: 13,
              borderRadius: 4,
              borderColor: state.isFocused ? '#86b7fe' : '#ddd',
            }),
            valueContainer: (base) => ({ ...base, padding: '0 10px' }),
            indicatorsContainer: (base) => ({ ...base, height: 34 }),
          }}
        />
      </div>

      <div style={{ fontSize: '10px', color: '#999', marginTop: '4px' }}>
        선택한 유형에 따라 Top 버튼의 디자인이 변경됩니다.
      </div>
    </div>
  );
};

export default ScrollToTopButtonControl;

